export enum StepType {
	DISCOVER = 'discover',
	EVALUATE = 'evaluate',
	PREPARE_TO_APPLY = 'apply',
	COMMIT = 'commit',
	STUDY = 'study',
	GET_READY = 'get_ready',
}
